import type { IconSvgObject } from './types';

const SpellCheckIcon: IconSvgObject = [
  ["path", { d: "M5.99219 13H14.9922", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.9922 14.8567L13.3817 7.82442C12.1874 4.60709 11.5902 2.99842 10.5508 3C9.51135 3.00158 8.91872 4.61206 7.73347 7.83302L3.99219 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.9922 19.3929C13.9922 19.3929 15.1922 20.0447 15.7922 21C15.7922 21 17.5922 17.25 19.9922 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SpellCheckIcon;
